function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { INPUT } from "../../components/form-styles";
import { Pill, Empty, Segmented } from "../../components/analytics-kit";
import Composer, { parseDesign, emptyDesign, starterDesign, SECTION_TYPES } from "../email-automation/composer";
import ContentPickList from "../email-automation/content-pick-list";
import { SubjectSuggest } from "../email-automation/ai-draft";
import Funnel from "./funnel";
import { num, railLabel, browserTimezone, dateOnly } from "./api";

/*
 * Campaign page sections (BULK_EMAIL_MANAGEMENT §13; one-page layout
 * 2026-10-09, replaces the five-step wizard). Pure, prop-driven: `c` is the
 * campaign model, `patch(section, fields)` merges into one section (or the
 * root when section is null). Every list / person / sender id is a STRING
 * here (see api.js).
 *
 *   1 Who it goes to  — AudienceSection: include chips, "Leave someone out", automatic exclusions, funnel
 *   2 What it says    — ContentSection: subject/preview line, email card, A/B ("try two subjects"); ContentEditor = overlay body
 *   3 When it sends   — WhenSection: now / on a date / every week, own time zone, From line, "More sending options"
 *   Preview + "Before it goes out" live in wizard.jsx.
 */

const inp = INPUT;
const small = {
  ...INPUT,
  width: 70,
  display: "inline-block",
  padding: "4px 7px",
  minHeight: 32
};

/** Kept for the Outreach wizard (views/outreach/wizard.jsx), which still renders a step rail and kind chips. */
export const STEP_NAMES = ["Audience", "Content", "Delivery", "Schedule", "Review"];
export const OUTREACH_TEXT = "A cold sequence to business contacts: plain-text emails sent one by one from your own warmed mailboxes, follow-ups in the same thread, stopping when someone replies.";
export const KINDS = [["broadcast", "Broadcast", "One send, one audience, one content. Schedule now, at a time, or at each recipient's local hour."], ["ab_test", "A/B test", "2 to 4 variants over subject or from name; sample, wait, winner metric, auto-send the winner."], ["recurring", "Recurring", "A template plus a cadence (weekly newsletter, monthly bulletin). Each occurrence is held as a Draft for approval."]];

// ------------------------------------------------------------------ pickers

/** "Start from…": a searchable list of sent campaigns; picking one duplicates it and continues in the copy. */
export class StartFromPicker extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      q: ""
    });
  }
  componentDidMount() {
    if (this.props.load) this.props.load();
  }
  render() {
    const {
      items,
      onPick,
      onClose
    } = this.props;
    const q = this.state.q.trim().toLowerCase();
    const rows = (items || []).filter(r => !q || `${r.name} ${r.subject || ""}`.toLowerCase().includes(q)).slice(0, 50);
    return /*#__PURE__*/React.createElement("div", {
      className: "ec-picker ec-startfrom-picker"
    }, /*#__PURE__*/React.createElement("input", {
      style: inp,
      autoFocus: true,
      value: this.state.q,
      placeholder: "Search emails you've sent",
      onChange: e => this.setState({
        q: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Escape") onClose();
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "ec-picker-list"
    }, !items ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, "Loading sent campaigns\u2026") : !rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, items.length ? "Nothing matches." : "You haven't sent a campaign yet.") : rows.map(r => /*#__PURE__*/React.createElement("button", {
      key: r.id,
      type: "button",
      onClick: () => onPick(r)
    }, /*#__PURE__*/React.createElement("span", null, r.name, r.subject ? /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, " \xB7 ", r.subject) : null), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, r.sentAt ? `sent ${dateOnly(r.sentAt)}` : "", r.kind === "ab_test" ? " · two subjects" : r.kind === "recurring" ? " · repeating" : "")))), /*#__PURE__*/React.createElement("div", {
      className: "ec-picker-foot"
    }, "Copies who it went to, the email, the sender and the timing into a new draft. ", /*#__PURE__*/React.createElement("a", {
      onClick: onClose
    }, "Close")));
  }
}
class ListPicker extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      q: ""
    });
  }
  render() {
    const {
      lists,
      chosen,
      onPick,
      onClose
    } = this.props;
    const q = this.state.q.trim().toLowerCase();
    const rows = (lists || []).filter(l => chosen.indexOf(l.id) < 0 && (!q || `${l.name} ${l.kind}`.toLowerCase().includes(q))).slice(0, 40);
    return /*#__PURE__*/React.createElement("div", {
      className: "ec-picker"
    }, /*#__PURE__*/React.createElement("input", {
      style: inp,
      autoFocus: true,
      value: this.state.q,
      placeholder: "Search lists",
      onChange: e => this.setState({
        q: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Escape") onClose();
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "ec-picker-list"
    }, !lists ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, "Loading lists\u2026") : !rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, "No list matches.") : rows.map(l => /*#__PURE__*/React.createElement("button", {
      key: l.id,
      type: "button",
      onClick: () => onPick(l.id)
    }, /*#__PURE__*/React.createElement("span", null, l.name), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, l.kind === "dynamic" ? "updates itself" : l.kind, l.total ? ` · ${num(l.total)}` : "")))), /*#__PURE__*/React.createElement("div", {
      className: "ec-picker-foot"
    }, /*#__PURE__*/React.createElement("a", {
      onClick: onClose
    }, "Close"), " \xB7 ", /*#__PURE__*/React.createElement(Link, {
      to: "/Audiences/this_month"
    }, "Manage lists")));
  }
}

// ------------------------------------------------------------------ 1 · Who it goes to

/** The plain sentence under the chips: what the estimate removes on its own, with the real counts. */
export function autoExclusionLine(c, estimate, estimating, wsSettings) {
  const a = c.audience;
  if (!(a.include || []).length && !(a.people || []).length) return "Add a list or a person to see how many people get it.";
  if (!estimate) return estimating ? "Counting…" : "The count appears once the campaign is saved (give it a name).";
  const cap = wsSettings && wsSettings.bulkCap || {
    max: 3,
    perHours: 168
  };
  const capDays = Math.max(1, Math.round((cap.perHours || 168) / 24));
  const days = wsSettings && wsSettings.inactivityDays || 365;
  const n = k => Number(estimate[k]) || 0;
  const parts = [];
  if (n("inactive")) parts.push(`${num(n("inactive"))} haven't done anything in ${days === 365 ? "a year" : `${num(days)} days`}`);
  if (n("frequencyCap")) parts.push(`${num(n("frequencyCap"))} already got ${cap.max} emails in the last ${capDays === 7 ? "week" : `${capDays} days`}`);
  if (n("suppressed")) parts.push(`${num(n("suppressed"))} unsubscribed, bounced or complained`);
  if (n("noConsent")) parts.push(`${num(n("noConsent"))} haven't agreed to get email`);
  if (n("duplicates")) parts.push(`${num(n("duplicates"))} are on more than one list or share an address`);
  if (n("invalid")) parts.push(`${num(n("invalid"))} have an address that can't receive mail`);
  const total = ["inactive", "frequencyCap", "suppressed", "noConsent", "duplicates", "invalid"].reduce((t, k) => t + n(k), 0);
  let line = total ? `${num(total)} left out automatically: ${parts.join(", ")}.` : "Nobody is left out automatically.";
  if (n("excluded")) line += ` ${num(n("excluded"))} more are on the lists you left out.`;
  if (a.excludeEmailedDays != null) line += ` Anyone emailed in the last ${a.excludeEmailedDays} day${a.excludeEmailedDays === 1 ? "" : "s"} is skipped too.`;
  return line;
}
export class AudienceSection extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      picking: null,
      leaveOut: false,
      rules: false,
      breakdown: false
    });
  }
  chip(id, onRemove) {
    const l = (this.props.lists || []).find(x => x.id === id);
    const name = l ? `${l.name}${l.total ? ` · ${num(l.total)}` : ""}` : `List ${id}`;
    return /*#__PURE__*/React.createElement("span", {
      key: id,
      className: "ecc-chip",
      title: l && l.kind === "dynamic" ? "This list updates itself" : undefined
    }, name, /*#__PURE__*/React.createElement("button", {
      type: "button",
      "aria-label": `Remove ${l ? l.name : "list"}`,
      onClick: onRemove
    }, "\u2715"));
  }
  render() {
    const {
      c,
      patch,
      lists,
      estimate,
      estimating,
      wsSettings
    } = this.props;
    const a = c.audience;
    const {
      picking,
      rules,
      breakdown
    } = this.state;
    const leaveOut = this.state.leaveOut || (a.exclude || []).length > 0;
    const setList = (field, ids) => patch("audience", {
      [field]: ids
    });
    const chosen = (a.include || []).concat(a.exclude || []);
    const cap = wsSettings && wsSettings.bulkCap || {
      max: 3,
      perHours: 168
    };
    const dup = estimate ? Number(estimate.duplicates) || 0 : 0;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "ecc-chips"
    }, (a.include || []).map(id => this.chip(id, () => setList("include", a.include.filter(x => x !== id)))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-addchip",
      onClick: () => this.setState({
        picking: picking === "include" ? null : "include"
      })
    }, "+ Add a list"), !leaveOut ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-textbtn",
      onClick: () => this.setState({
        leaveOut: true,
        picking: "exclude"
      })
    }, "Leave someone out") : null), picking === "include" ? /*#__PURE__*/React.createElement(ListPicker, {
      lists: lists,
      chosen: chosen,
      onPick: id => {
        setList("include", (a.include || []).concat([id]));
        this.setState({
          picking: null
        });
      },
      onClose: () => this.setState({
        picking: null
      })
    }) : null, leaveOut ? /*#__PURE__*/React.createElement("div", {
      className: "ecc-leaveout"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ecc-sublabel"
    }, "Leave out anyone on"), /*#__PURE__*/React.createElement("div", {
      className: "ecc-chips"
    }, (a.exclude || []).map(id => this.chip(id, () => setList("exclude", a.exclude.filter(x => x !== id)))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-addchip",
      onClick: () => this.setState({
        picking: picking === "exclude" ? null : "exclude"
      })
    }, "+ Add a list"), !(a.exclude || []).length ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-textbtn",
      onClick: () => this.setState({
        leaveOut: false,
        picking: null
      })
    }, "Cancel") : null), picking === "exclude" ? /*#__PURE__*/React.createElement(ListPicker, {
      lists: lists,
      chosen: chosen,
      onPick: id => {
        setList("exclude", (a.exclude || []).concat([id]));
        this.setState({
          picking: null
        });
      },
      onClose: () => this.setState({
        picking: null
      })
    }) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "ecc-note"
    }, autoExclusionLine(c, estimate, estimating, wsSettings), " ", /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-link",
      onClick: () => this.setState({
        rules: !rules
      })
    }, rules ? "Done" : "Change"), estimate ? /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-link",
      onClick: () => this.setState({
        breakdown: !breakdown
      })
    }, breakdown ? "Hide the breakdown" : "See the breakdown")) : null), rules ? /*#__PURE__*/React.createElement("div", {
      className: "ecc-rules"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: a.excludeInactive !== false,
      onChange: e => patch("audience", {
        excludeInactive: e.target.checked
      })
    }), " Skip people who haven't done anything in ", num(wsSettings && wsSettings.inactivityDays || 365), " days"), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: a.excludeEmailedDays != null,
      onChange: e => patch("audience", {
        excludeEmailedDays: e.target.checked ? 3 : null
      })
    }), " Skip anyone emailed in the last", /*#__PURE__*/React.createElement("input", {
      style: {
        ...small,
        width: 56,
        margin: "0 6px"
      },
      type: "number",
      min: "1",
      max: "90",
      "aria-label": "Days",
      disabled: a.excludeEmailedDays == null,
      value: a.excludeEmailedDays == null ? "" : a.excludeEmailedDays,
      onChange: e => patch("audience", {
        excludeEmailedDays: Math.max(1, Number(e.target.value) || 1)
      })
    }), " days"), /*#__PURE__*/React.createElement("label", {
      className: "dim"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: true,
      disabled: true
    }), " Never more than ", cap.max, " emails per person every ", Math.round((cap.perHours || 168) / 24), " days (", /*#__PURE__*/React.createElement(Link, {
      to: "/Email/settings"
    }, "change in Settings"), ")")) : null, breakdown && estimate ? /*#__PURE__*/React.createElement("div", {
      className: "ecc-breakdown"
    }, /*#__PURE__*/React.createElement(Funnel, {
      f: estimate,
      pending: estimating
    }), /*#__PURE__*/React.createElement("div", {
      className: "mini",
      style: {
        marginTop: 8
      }
    }, "The final count is worked out again when it sends", estimate.computedDate ? `; counted ${moment(estimate.computedDate).fromNow()}` : "", ".", dup > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", num(dup), " possible duplicates are waiting in ", /*#__PURE__*/React.createElement(Link, {
      to: "/Audiences/this_month"
    }, "Audiences, Duplicates"), ".") : null), Array.isArray(estimate.notes) && estimate.notes.length ? /*#__PURE__*/React.createElement("ul", {
      className: "ec-notes"
    }, estimate.notes.map((n, i) => /*#__PURE__*/React.createElement("li", {
      key: i
    }, n))) : null) : null);
  }
}

// ------------------------------------------------------------------ 2 · What it says (+ A/B variants)

const WINNER_LABEL = {
  clicks: "clicks",
  opens: "opens",
  conversions: "sales"
};

/** One timeline sentence for the test: "20 % get a version now, the one with more clicks after 4 hours goes to the other 80 %". */
export function abTimeline(v) {
  const sample = Number(v.sample) || 20;
  const hours = Math.round((Number(v.waitMinutes) || 240) / 60);
  const metric = WINNER_LABEL[v.winnerMetric] || v.winnerMetric || "clicks";
  const tail = v.autoWinner === false ? `you pick the winner for the other ${100 - sample} %` : `the winner goes to the other ${100 - sample} %`;
  return `${sample} % get a version first, the one with the most ${metric} after ${hours} hour${hours === 1 ? "" : "s"} wins, then ${tail}`;
}
export function VariantCards({
  c,
  patch
}) {
  const v = c.variants || {
    variants: []
  };
  const list = v.variants || [];
  const setVariant = (i, fields) => patch("variants", {
    variants: list.map((x, k) => k === i ? {
      ...x,
      ...fields
    } : x)
  });
  const a = list[0] || {};
  const sample = Number(v.sample) || 20;
  return /*#__PURE__*/React.createElement("div", {
    className: "ec-ab ecc-ab"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ec-variant-cards"
  }, list.map((x, i) => {
    const subjDiff = i > 0 && (x.subject || "").trim() !== (a.subject || "").trim();
    const fromDiff = i > 0 && (x.fromName || "").trim() !== (a.fromName || "").trim();
    return /*#__PURE__*/React.createElement("div", {
      className: "ec-variant-card",
      key: x.key || i
    }, /*#__PURE__*/React.createElement("div", {
      className: "ec-variant-head"
    }, /*#__PURE__*/React.createElement("b", null, "Version ", x.key), /*#__PURE__*/React.createElement("span", {
      className: "mini"
    }, Math.round(sample / list.length), " % of the test group"), list.length > 2 ? /*#__PURE__*/React.createElement("a", {
      className: "dim right",
      onClick: () => patch("variants", {
        variants: list.filter((_, k) => k !== i)
      }),
      title: "Remove this version"
    }, "\xD7") : null), /*#__PURE__*/React.createElement("label", {
      className: "ecc-label"
    }, "Subject"), /*#__PURE__*/React.createElement("input", {
      style: inp,
      placeholder: i === 0 ? c.content.subject || `Subject ${x.key}` : `Subject ${x.key}`,
      value: x.subject || "",
      onChange: e => setVariant(i, {
        subject: e.target.value
      })
    }), /*#__PURE__*/React.createElement("label", {
      className: "ecc-label"
    }, "From name ", /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "(optional)")), /*#__PURE__*/React.createElement("input", {
      style: inp,
      placeholder: "Same as the sender",
      value: x.fromName || "",
      onChange: e => setVariant(i, {
        fromName: e.target.value
      })
    }), i > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "ec-variant-diff"
    }, subjDiff ? /*#__PURE__*/React.createElement(Pill, {
      tone: "info"
    }, "different subject") : /*#__PURE__*/React.createElement(Pill, {
      tone: "warning"
    }, "same subject as A"), fromDiff ? /*#__PURE__*/React.createElement(Pill, {
      tone: "info"
    }, "different from name") : null) : null);
  }), list.length < 4 ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "ec-variant-add",
    onClick: () => patch("variants", {
      variants: list.concat([{
        key: String.fromCharCode(65 + list.length),
        subject: ""
      }])
    })
  }, "+ Version ", String.fromCharCode(65 + list.length)) : null), /*#__PURE__*/React.createElement("div", {
    className: "ecc-inline ecc-ab-controls"
  }, "Test on ", /*#__PURE__*/React.createElement("input", {
    type: "number",
    min: "10",
    max: "50",
    "aria-label": "Test group percent",
    style: {
      ...small,
      width: 60
    },
    value: sample,
    onChange: e => patch("variants", {
      sample: Math.max(10, Math.min(50, Number(e.target.value) || 20))
    })
  }), " % of people, pick the winner by ", /*#__PURE__*/React.createElement("select", {
    style: {
      ...small,
      width: 120
    },
    "aria-label": "Winner by",
    value: v.winnerMetric || "clicks",
    onChange: e => patch("variants", {
      winnerMetric: e.target.value
    })
  }, /*#__PURE__*/React.createElement("option", {
    value: "clicks"
  }, "clicks"), /*#__PURE__*/React.createElement("option", {
    value: "opens"
  }, "opens"), /*#__PURE__*/React.createElement("option", {
    value: "conversions"
  }, "sales")), "after ", /*#__PURE__*/React.createElement("input", {
    type: "number",
    min: "1",
    max: "24",
    "aria-label": "Hours",
    style: {
      ...small,
      width: 56
    },
    value: Math.round((v.waitMinutes || 240) / 60),
    onChange: e => patch("variants", {
      waitMinutes: Math.max(1, Math.min(24, Number(e.target.value) || 4)) * 60
    })
  }), " hours", /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: v.autoWinner !== false,
    onChange: e => patch("variants", {
      autoWinner: e.target.checked
    })
  }), " send the winner automatically")), /*#__PURE__*/React.createElement("div", {
    className: "ecc-note"
  }, abTimeline(v), "."));
}
const STARTER_CHOICES = [["ProductViewed", "Products viewed"], ["CartAbandoned", "Cart recovery"], ["WelcomeSeries", "Welcome"], ["CustomerLoyalty", "Thank you"], ["custom", "Blank note"]];

/** What the "email card" says about the current content. */
export function contentSummary(c) {
  const ct = c.content;
  const src = ct.source || "composer";
  if (src === "raw") {
    const len = (ct.html || "").trim().length;
    return len ? {
      title: "Your own HTML",
      sub: `${num(len)} characters · the footer and unsubscribe link are added when it sends`,
      ready: true
    } : {
      title: "No HTML yet",
      sub: "Paste the email's HTML to use your own design.",
      ready: false
    };
  }
  if (src === "content_hub") {
    return ct.variantId ? {
      title: c.containerTitle || "A Content Hub piece",
      sub: "Copied from Content Hub · edit it here if needed",
      ready: true
    } : {
      title: "No Content Hub piece yet",
      sub: "Pick a piece to copy its email in.",
      ready: false
    };
  }
  const d = parseDesign(ct.designJson);
  const sections = d && d.sections || [];
  if (!sections.length) return {
    title: "No email yet",
    sub: "Start from a layout, or build it block by block.",
    ready: false
  };
  const names = sections.map(s => {
    const m = SECTION_TYPES.find(([t]) => t === s.type);
    return (m ? m[1] : s.type).toLowerCase();
  });
  const shown = names.slice(0, 5).join(", ") + (names.length > 5 ? `, and ${names.length - 5} more` : "");
  return {
    title: `${sections.length} block${sections.length === 1 ? "" : "s"} in your brand layout`,
    sub: `${shown.charAt(0).toUpperCase()}${shown.slice(1)} · from your brand kit`,
    ready: true
  };
}
export class ContentSection extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      pickOpen: false
    });
    _defineProperty(this, "pickStarter", k => {
      const {
        c,
        patch
      } = this.props;
      const d = parseDesign(c.content.designJson);
      const has = (c.content.source || "composer") === "composer" ? !!(d && (d.sections || []).length) : !!(c.content.html || "").trim();
      if (has && typeof window !== "undefined" && window.confirm && !window.confirm("Replace the current email with this layout?")) return;
      patch("content", {
        source: "composer",
        designJson: JSON.stringify(starterDesign(k))
      });
      this.setState({
        pickOpen: false
      });
    });
    _defineProperty(this, "pickSource", s => {
      this.props.patch("content", {
        source: s
      });
      this.setState({
        pickOpen: false
      });
      this.props.onEdit(s === "content_hub" ? {
        hubOpen: true
      } : undefined);
    });
  }
  render() {
    const {
      c,
      patch,
      onEdit,
      locked
    } = this.props;
    const ct = c.content;
    const ab = c.kind === "ab_test";
    const sum = contentSummary(c);
    const {
      pickOpen
    } = this.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "ecc-grid2"
    }, /*#__PURE__*/React.createElement("label", {
      className: "ecc-field"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ecc-label"
    }, ab ? "Backup subject" : "Subject"), /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: ct.subject || "",
      placeholder: "What people see in their inbox",
      onChange: e => patch("content", {
        subject: e.target.value
      })
    })), /*#__PURE__*/React.createElement("label", {
      className: "ecc-field"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ecc-label"
    }, "Preview line"), /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: ct.preheader || "",
      placeholder: "The short line shown after the subject",
      onChange: e => patch("content", {
        preheader: e.target.value
      })
    }))), /*#__PURE__*/React.createElement(SubjectSuggest, {
      kind: "custom",
      triggerType: c.kind || "broadcast",
      subject: ct.subject,
      preheader: ct.preheader,
      onUse: p => patch("content", {
        subject: p.subject || ct.subject || "",
        preheader: p.preheader || ct.preheader || ""
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "ecc-emailcard" + (sum.ready ? "" : " empty")
    }, /*#__PURE__*/React.createElement("span", {
      className: "ecc-thumb",
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("div", {
      className: "ecc-emailcard-text"
    }, /*#__PURE__*/React.createElement("b", null, sum.title), /*#__PURE__*/React.createElement("span", null, sum.sub)), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-btn ecc-btn-dark",
      onClick: () => onEdit()
    }, sum.ready ? "Edit the email" : "Create the email"), !locked ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-textbtn",
      onClick: () => this.setState({
        pickOpen: !pickOpen
      })
    }, pickOpen ? "Close" : "Pick another") : null), pickOpen ? /*#__PURE__*/React.createElement("div", {
      className: "ecc-pick"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ecc-sublabel"
    }, "Start from a layout"), /*#__PURE__*/React.createElement("div", {
      className: "ecc-chips"
    }, STARTER_CHOICES.map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      type: "button",
      className: "ecc-addchip solid",
      onClick: () => this.pickStarter(k)
    }, l))), /*#__PURE__*/React.createElement("span", {
      className: "ecc-sublabel"
    }, "Or"), /*#__PURE__*/React.createElement("div", {
      className: "ecc-chips"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-addchip solid",
      onClick: () => this.pickSource("content_hub")
    }, "Use a Content Hub piece"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-addchip solid",
      onClick: () => this.pickSource("raw")
    }, "Paste your own HTML"), (ct.source || "composer") !== "composer" ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-addchip solid",
      onClick: () => this.pickSource("composer")
    }, "Build it block by block") : null)) : null, /*#__PURE__*/React.createElement("label", {
      className: "ecc-check"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: ab,
      onChange: e => patch(null, {
        kind: e.target.checked ? "ab_test" : "broadcast"
      })
    }), " Try two subjects on a small group first, then send the winner"), ab ? /*#__PURE__*/React.createElement(VariantCards, {
      c: c,
      patch: patch
    }) : null);
  }
}

/** The body of the "Edit the email" overlay: how the email is built, the builder itself, and the plain-text version. */
export class ContentEditor extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      hubOpen: !!this.props.hubOpen
    });
  }
  componentDidMount() {
    if (this.state.hubOpen && this.props.loadContentPicks) this.props.loadContentPicks();
  }
  render() {
    const {
      c,
      patch,
      brand,
      renderPreview,
      contentPicks,
      loadContentPicks,
      pickContainer,
      hubAvailable
    } = this.props;
    const ct = c.content;
    const design = parseDesign(ct.designJson) || emptyDesign();
    const src = ct.source || "composer";
    const setSource = s => {
      if (s === "content_hub" && !hubAvailable) return;
      patch("content", {
        source: s
      });
      if (s === "content_hub") {
        this.setState({
          hubOpen: true
        });
        if (loadContentPicks) loadContentPicks();
      }
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "ecc-editor-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ecc-inline"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ecc-label",
      style: {
        margin: 0
      }
    }, "How you build it"), /*#__PURE__*/React.createElement(Segmented, {
      value: src,
      onChange: setSource,
      options: [["composer", "Blocks"], ["raw", "Your own HTML"], ["content_hub", hubAvailable ? "Content Hub piece" : "Content Hub piece (not available)"]]
    })), src === "content_hub" && !hubAvailable ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "Content Hub pieces can't be used here yet; build it with blocks or paste HTML for now.") : null, src === "composer" ? /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 12
      }
    }, /*#__PURE__*/React.createElement(Composer, {
      design: design,
      brand: brand,
      kind: "custom",
      triggerType: c.kind || "broadcast",
      onChange: d => patch("content", {
        designJson: JSON.stringify(d)
      }),
      onPickStarter: k => patch("content", {
        designJson: JSON.stringify(starterDesign(k))
      }),
      renderPreview: renderPreview,
      onSendTest: this.props.onSendTest,
      testBusy: this.props.testBusy,
      testNote: this.props.testNote
    })) : null, src === "raw" ? /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 12
      }
    }, /*#__PURE__*/React.createElement("label", {
      className: "ecc-label"
    }, "HTML"), /*#__PURE__*/React.createElement("textarea", {
      style: {
        ...inp,
        minHeight: 320,
        fontFamily: "ui-monospace, Menlo, monospace",
        fontSize: 12
      },
      value: ct.html || "",
      placeholder: "<html>\u2026</html>",
      onChange: e => patch("content", {
        html: e.target.value
      })
    }), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "6px 0 0"
      }
    }, "The footer, the unsubscribe link and link tracking are added when it sends. Personalize with ", "{{FirstName}}", ".")) : null, src === "content_hub" && hubAvailable ? /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 12
      },
      className: "ec-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h3"
    }, "Content Hub piece"), c.containerTitle ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "Using \u201C", c.containerTitle, "\u201D. Its email was copied into this campaign; switch to Your own HTML to change it.") : null, !this.state.hubOpen ? /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      onClick: () => {
        this.setState({
          hubOpen: true
        });
        if (loadContentPicks) loadContentPicks();
      }
    }, ct.variantId ? "Pick another piece" : "Pick a piece") : /*#__PURE__*/React.createElement("div", {
      className: "ec-picker static"
    }, !contentPicks ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, "Loading pieces\u2026") : !contentPicks.length ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, "No Content Hub pieces this quarter.") : /*#__PURE__*/React.createElement(ContentPickList, {
      items: contentPicks,
      maxHeight: 320,
      pickTitle: "Use this piece's email",
      onPick: p => {
        pickContainer(p);
        this.setState({
          hubOpen: false
        });
      },
      meta: p => `${p.stage || p.status || ""}${p.sessions ? `${p.stage || p.status ? " · " : ""}${num(p.sessions)} visits` : ""}`
    }), /*#__PURE__*/React.createElement("div", {
      className: "ec-picker-foot"
    }, /*#__PURE__*/React.createElement("a", {
      onClick: () => this.setState({
        hubOpen: false
      })
    }, "Close")))) : null, /*#__PURE__*/React.createElement("label", {
      className: "ecc-label",
      style: {
        marginTop: 16
      }
    }, "Plain-text version ", /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "(optional; inboxes trust emails that include one)")), /*#__PURE__*/React.createElement("textarea", {
      style: {
        ...inp,
        minHeight: 90
      },
      value: ct.text || "",
      onChange: e => patch("content", {
        text: e.target.value
      })
    }));
  }
}

// ------------------------------------------------------------------ 3 · When it sends (+ sender, sending service, follow-up, speed)

export function domainTone(s) {
  return {
    verified: "success",
    pending: "warning",
    failed: "danger"
  }[String(s || "none").toLowerCase()] || "neutral";
}
export function domainLabel(s) {
  return {
    verified: "verified",
    pending: "DNS pending",
    failed: "DNS failed",
    none: "not authenticated"
  }[String(s || "none").toLowerCase()] || s;
}
const SERVICE_NOTES = {
  plunk: "Sends from your own domain. Can test subjects, senders, content and timing; results arrive as they happen.",
  mailchimp: "Sends through your Mailchimp account. Send times round up to the next quarter hour; results arrive as Mailchimp reports them.",
  constant_contact: "Sends through your Constant Contact account. Can test subjects only; results arrive about once an hour.",
  smartlead: "Only for outreach to business contacts."
};
function SenderCards({
  c,
  patch,
  senders
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "ec-radio-cards",
    style: {
      marginTop: 8
    }
  }, senders.map(s => /*#__PURE__*/React.createElement("div", {
    key: s.id,
    className: "ec-radio-card" + (c.senderId === s.id ? " sel" : ""),
    onClick: () => patch(null, {
      senderId: s.id
    }),
    role: "radio",
    "aria-checked": c.senderId === s.id
  }, /*#__PURE__*/React.createElement("b", null, s.fromName, " ", s.isDefault ? /*#__PURE__*/React.createElement(Pill, {
    tone: "info"
  }, "default") : null), /*#__PURE__*/React.createElement("span", null, s.fromEmail, s.replyTo ? ` · replies go to ${s.replyTo}` : ""), /*#__PURE__*/React.createElement("span", {
    className: "row",
    style: {
      marginTop: 6
    }
  }, /*#__PURE__*/React.createElement(Pill, {
    tone: domainTone(s.domainAuthStatus)
  }, domainLabel(s.domainAuthStatus)), s.linkBrandingStatus === "verified" ? /*#__PURE__*/React.createElement(Pill, {
    tone: "success"
  }, "branded links") : null, /*#__PURE__*/React.createElement("span", {
    className: "code"
  }, s.domain)))));
}
function ServiceCards({
  c,
  patch,
  rails,
  sender
}) {
  const items = rails && rails.items || [];
  const byName = {};
  items.forEach(r => {
    byName[String(r.rail).toLowerCase()] = r;
  });
  const order = ["plunk", "mailchimp", "constant_contact"]; // Smartlead retired 2026-10-03
  return /*#__PURE__*/React.createElement("div", {
    className: "ec-rail-cards",
    style: {
      marginTop: 8
    }
  }, order.map(name => {
    const r = byName[name] || {
      rail: name,
      status: "disconnected"
    };
    const connected = name === "plunk" || r.connected || r.status === "connected";
    const selectable = name !== "smartlead" && connected;
    const sel = (c.rail || "plunk") === name;
    const caps = r.capabilities || {};
    const ab = Array.isArray(caps.abTest) ? caps.abTest : [];
    return /*#__PURE__*/React.createElement("div", {
      key: name,
      className: "ec-rail-card" + (sel ? " sel" : "") + (selectable ? "" : " off"),
      onClick: () => selectable && patch(null, {
        rail: name
      }),
      role: "radio",
      "aria-checked": sel
    }, /*#__PURE__*/React.createElement("b", null, railLabel(name), " ", rails && name === rails.default ? /*#__PURE__*/React.createElement(Pill, {
      tone: "info"
    }, "default") : null, name !== "plunk" ? /*#__PURE__*/React.createElement(Pill, {
      tone: connected ? "success" : "neutral"
    }, connected ? "connected" : "not connected") : null), /*#__PURE__*/React.createElement("span", null, SERVICE_NOTES[name]), /*#__PURE__*/React.createElement("ul", null, name === "plunk" ? /*#__PURE__*/React.createElement("li", null, "sends from ", /*#__PURE__*/React.createElement("b", null, sender ? sender.domain || sender.fromEmail : "the sender above"), sender ? ` (${domainLabel(sender.domainAuthStatus)})` : "") : null, name === "mailchimp" ? /*#__PURE__*/React.createElement("li", null, r.config && (r.config.listName || r.config.listId) ? `uses the Mailchimp audience ${r.config.listName || r.config.listId}` : "uses one Mailchimp audience for the workspace") : null, name === "constant_contact" ? /*#__PURE__*/React.createElement("li", null, "the sender must be verified in Constant Contact") : null, ab.length && name !== "plunk" ? /*#__PURE__*/React.createElement("li", null, "can test: ", ab.join(", ")) : null, name !== "plunk" && !connected ? /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
      to: "/Email/settings",
      onClick: e => e.stopPropagation()
    }, "Connect it in Email settings")) : null));
  }));
}
export const LOCAL_HOUR_COPY = "Sends over the 24 hours after you schedule it, as that hour arrives where each person is; people whose location isn't known get it at that hour in the campaign's time zone.";
/** schedule.localDate (2026-10-08): "On a date" with "In each person's own time zone" ticked. */
export const LOCAL_DATE_COPY = "Each person gets it at that hour on that date where they are, so it goes out over about a day as the date reaches each time zone. People whose location isn't known get it at that hour in the campaign's time zone.";

/** The planned resend date: the send moment plus N days. */
export function resendDate(c) {
  const r = c.settings && c.settings.resend;
  if (!r) return null;
  const base = c.schedule && c.schedule.mode === "at" && c.schedule.sendAt ? moment(c.schedule.sendAt) : moment();
  return base.add(Number(r.afterDays) || 3, "days").toDate();
}
const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const hourText = h => moment().hour(Number(h) || 0).minute(0).format("h:mm A");
export const DEFAULT_CADENCE = {
  unit: "weekly",
  dayOfWeek: 2,
  hour: 9,
  leadHours: 24
};
export class WhenSection extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      senderOpen: false,
      providerOpen: false,
      more: false
    });
    /** "In each person's own time zone" on or off, keeping the tab: on "On a date" the picked date carries over both ways. */
    _defineProperty(this, "toggleLocal", (on, tab, tz) => {
      const s = this.props.c.schedule;
      if (on) {
        const localDate = tab === "at" ? s.sendAt ? moment(s.sendAt).format("YYYY-MM-DD") : moment().add(1, "day").format("YYYY-MM-DD") : null;
        const localHour = tab === "at" && s.sendAt ? moment(s.sendAt).hour() : s.localHour == null ? 10 : s.localHour;
        this.props.patch("schedule", {
          mode: "local",
          localDate,
          localHour,
          timezone: tz
        });
        return;
      }
      if (tab === "at") {
        const at = s.localDate ? moment(`${s.localDate}T${String(s.localHour == null ? 10 : s.localHour).padStart(2, "0")}:00`, "YYYY-MM-DDTHH:mm") : null;
        this.props.patch("schedule", {
          mode: "at",
          localDate: null,
          sendAt: at && at.isValid() ? at.toDate().toISOString() : s.sendAt,
          timezone: tz
        });
        return;
      }
      this.props.patch("schedule", {
        mode: "now",
        localDate: null,
        timezone: tz
      });
    });
  }
  render() {
    const {
      c,
      patch,
      wsSettings,
      senders,
      railSenders,
      rails
    } = this.props;
    const s = c.schedule;
    const tz = s.timezone || browserTimezone();
    const mode = s.mode === "sto" ? "now" : s.mode || "now"; // "best time per recipient" retired 2026-10-04
    const recurring = c.kind === "recurring";
    // local + "On a date": schedule.localDate is set ("" while the date is still being picked); local + "Now": localDate null
    const localOnDate = mode === "local" && s.localDate != null;
    const tab = recurring ? "weekly" : mode === "at" || localOnDate ? "at" : "now";
    const tomorrow = () => moment().add(1, "day").format("YYYY-MM-DD");
    const cad = {
      ...DEFAULT_CADENCE,
      ...(s.cadence || {})
    };
    const setCad = f => patch("schedule", {
      cadence: {
        ...cad,
        ...f
      }
    });
    // Root patch so the kind and the schedule mode change together (two patches in one click would race).
    const pick = t => {
      if (t === "weekly") {
        patch(null, {
          kind: "recurring",
          schedule: {
            ...s,
            cadence: s.cadence || {
              ...DEFAULT_CADENCE
            },
            timezone: tz
          }
        });
        return;
      }
      const kind = recurring ? "broadcast" : c.kind;
      if (mode === "local") {
        const localDate = t === "at" ? s.localDate || (s.sendAt ? moment(s.sendAt).format("YYYY-MM-DD") : tomorrow()) : null;
        patch(null, {
          kind,
          schedule: {
            ...s,
            mode: "local",
            localDate,
            timezone: tz
          }
        });
        return;
      }
      const m = t === "at" ? "at" : "now";
      patch(null, {
        kind,
        schedule: {
          ...s,
          mode: m,
          localDate: null,
          timezone: tz
        }
      });
    };
    const sendAt = s.sendAt ? moment(s.sendAt) : null;
    const setAt = (date, time) => {
      const d = date || (sendAt ? sendAt.format("YYYY-MM-DD") : moment().add(1, "day").format("YYYY-MM-DD"));
      const t = time || (sendAt ? sendAt.format("HH:mm") : "09:00");
      const m = moment(`${d}T${t}`, "YYYY-MM-DDTHH:mm");
      patch("schedule", {
        sendAt: m.isValid() ? m.toDate().toISOString() : null,
        timezone: tz
      });
    };
    const plunk = (c.rail || "plunk") === "plunk";
    const sender = (senders || []).find(x => x.id === c.senderId);
    const senderOpen = this.state.senderOpen || plunk && senders && senders.length > 0 && !sender;
    const resend = c.settings && c.settings.resend || null;
    const throttle = s.throttlePerHour || wsSettings && wsSettings.throttlePerHour || 50000;
    const planned = resendDate(c);
    const {
      more
    } = this.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "ecc-seg",
      role: "radiogroup",
      "aria-label": "When it sends"
    }, [["now", "Now"], ["at", "On a date"], ["weekly", "Every week"]].map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      type: "button",
      role: "radio",
      "aria-checked": tab === k,
      className: tab === k ? "on" : "",
      onClick: () => pick(k)
    }, l))), tab === "weekly" ? /*#__PURE__*/React.createElement("div", {
      className: "ecc-inline"
    }, "Repeats every", /*#__PURE__*/React.createElement("select", {
      style: {
        ...small,
        width: 100
      },
      "aria-label": "How often",
      value: cad.unit,
      onChange: e => setCad({
        unit: e.target.value
      })
    }, /*#__PURE__*/React.createElement("option", {
      value: "weekly"
    }, "week"), /*#__PURE__*/React.createElement("option", {
      value: "monthly"
    }, "month")), cad.unit === "weekly" ? /*#__PURE__*/React.createElement(React.Fragment, null, "on ", /*#__PURE__*/React.createElement("select", {
      style: {
        ...small,
        width: 130
      },
      "aria-label": "Day of the week",
      value: cad.dayOfWeek,
      onChange: e => setCad({
        dayOfWeek: Number(e.target.value)
      })
    }, DAYS.map((d, i) => /*#__PURE__*/React.createElement("option", {
      key: d,
      value: i
    }, d)))) : /*#__PURE__*/React.createElement(React.Fragment, null, "on day ", /*#__PURE__*/React.createElement("input", {
      type: "number",
      min: "1",
      max: "28",
      "aria-label": "Day of the month",
      style: {
        ...small,
        width: 60
      },
      value: cad.dayOfMonth || 1,
      onChange: e => setCad({
        dayOfMonth: Math.max(1, Math.min(28, Number(e.target.value) || 1))
      })
    })), "at ", /*#__PURE__*/React.createElement("input", {
      type: "number",
      min: "0",
      max: "23",
      "aria-label": "Hour",
      style: {
        ...small,
        width: 60
      },
      value: cad.hour,
      onChange: e => setCad({
        hour: Math.max(0, Math.min(23, Number(e.target.value) || 0))
      })
    }), " :00 ", /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, tz)) : null, tab === "weekly" ? /*#__PURE__*/React.createElement("div", {
      className: "ecc-note"
    }, "Each one is prepared ", cad.leadHours || 24, " hours ahead and waits as a draft for approval, unless your workspace can send without review.") : null, tab === "at" && mode !== "local" ? /*#__PURE__*/React.createElement("div", {
      className: "ecc-inline"
    }, /*#__PURE__*/React.createElement("input", {
      type: "date",
      "aria-label": "Date",
      style: {
        ...inp,
        width: 170
      },
      value: sendAt ? sendAt.format("YYYY-MM-DD") : "",
      onChange: e => setAt(e.target.value, null)
    }), /*#__PURE__*/React.createElement("input", {
      type: "time",
      "aria-label": "Time",
      style: {
        ...inp,
        width: 130
      },
      value: sendAt ? sendAt.format("HH:mm") : "",
      onChange: e => setAt(null, e.target.value)
    }), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, tz)) : null, tab !== "weekly" ? /*#__PURE__*/React.createElement("label", {
      className: "ecc-check"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: mode === "local",
      onChange: e => this.toggleLocal(e.target.checked, tab, tz)
    }), " In each person's own time zone") : null, mode === "local" && tab === "at" ? /*#__PURE__*/React.createElement("div", {
      className: "ecc-inline"
    }, /*#__PURE__*/React.createElement("input", {
      type: "date",
      "aria-label": "Date",
      style: {
        ...inp,
        width: 170
      },
      min: moment().format("YYYY-MM-DD"),
      value: s.localDate || "",
      onChange: e => patch("schedule", {
        localDate: e.target.value || "",
        timezone: tz
      })
    })) : null, mode === "local" && tab !== "weekly" ? /*#__PURE__*/React.createElement("div", {
      className: "ecc-inline"
    }, "Arrives at ", /*#__PURE__*/React.createElement("input", {
      type: "number",
      min: "0",
      max: "23",
      "aria-label": "Hour",
      style: {
        ...small,
        width: 60
      },
      value: s.localHour == null ? 10 : s.localHour,
      onChange: e => patch("schedule", {
        localHour: Math.max(0, Math.min(23, Number(e.target.value) || 0))
      })
    }), " :00 their time", /*#__PURE__*/React.createElement("span", {
      className: "ecc-note",
      style: {
        flexBasis: "100%"
      }
    }, tab === "at" ? LOCAL_DATE_COPY : LOCAL_HOUR_COPY, " That time zone is ", /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, tz), ".")) : null, s.mode === "sto" ? /*#__PURE__*/React.createElement("div", {
      className: "ecc-note warn"
    }, "\"Best time per person\" is no longer offered, so this campaign now sends as soon as it is scheduled. Pick another option if that isn't what you want.") : null, /*#__PURE__*/React.createElement("div", {
      className: "ecc-note ecc-from"
    }, plunk ? !senders ? "Loading senders…" : !senders.length ? /*#__PURE__*/React.createElement(React.Fragment, null, "No sender yet. ", /*#__PURE__*/React.createElement(Link, {
      to: "/Email/settings"
    }, "Add one in Email settings"), " and confirm its domain.") : sender ? /*#__PURE__*/React.createElement(React.Fragment, null, "From ", sender.fromName, " <", sender.fromEmail, ">", senders.length > 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-link",
      onClick: () => this.setState({
        senderOpen: !senderOpen
      })
    }, senderOpen ? "Done" : "Change")) : /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", /*#__PURE__*/React.createElement(Link, {
      to: "/Email/settings"
    }, "Change"))) : "Pick who it comes from:" : /*#__PURE__*/React.createElement(React.Fragment, null, "From your ", railLabel(c.rail), " verified address \xB7 ", /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-link",
      onClick: () => this.setState({
        providerOpen: !this.state.providerOpen
      })
    }, this.state.providerOpen ? "Hide" : "Show them"))), plunk && sender && String(sender.domainAuthStatus || "").toLowerCase() !== "verified" ? /*#__PURE__*/React.createElement("div", {
      className: "ecc-note bad"
    }, "This sender's domain isn't confirmed yet, so the campaign can't go out from it. Confirm it in ", /*#__PURE__*/React.createElement(Link, {
      to: "/Email/settings"
    }, "Email settings"), " or pick another sender.") : null, plunk && senderOpen && senders && senders.length ? /*#__PURE__*/React.createElement(SenderCards, {
      c: c,
      patch: patch,
      senders: senders
    }) : null, !plunk && this.state.providerOpen ? railSenders == null ? /*#__PURE__*/React.createElement("div", {
      className: "territory-hint"
    }, "Loading ", railLabel(c.rail), "'s verified senders\u2026") : railSenders.error ? /*#__PURE__*/React.createElement("div", {
      className: "wa-notice warning"
    }, railSenders.error) : !(railSenders.items || []).length ? /*#__PURE__*/React.createElement(Empty, null, railLabel(c.rail), " didn't return any verified From addresses.") : /*#__PURE__*/React.createElement("ul", {
      className: "wa-list"
    }, railSenders.items.map((x, i) => /*#__PURE__*/React.createElement("li", {
      key: i
    }, /*#__PURE__*/React.createElement("b", null, x.name || x.fromName || x.from_name || ""), " ", x.email || x.fromEmail || x.from_email || JSON.stringify(x)))) : null, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "ecc-disclosure",
      "aria-expanded": more,
      onClick: () => this.setState({
        more: !more
      })
    }, /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, more ? "▾" : "▸"), " More sending options"), more ? /*#__PURE__*/React.createElement("div", {
      className: "ecc-more"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ecc-more-block"
    }, /*#__PURE__*/React.createElement("b", null, "Send it through"), /*#__PURE__*/React.createElement("span", {
      className: "ecc-note"
    }, "Plunk keeps your lists, approvals and results whichever service sends it."), /*#__PURE__*/React.createElement(ServiceCards, {
      c: c,
      patch: patch,
      rails: rails,
      sender: sender
    }), c.kind === "ab_test" && c.rail === "constant_contact" ? /*#__PURE__*/React.createElement("div", {
      className: "ecc-note"
    }, "Constant Contact can only test the subject: Plunk splits the people into two sends.") : null), /*#__PURE__*/React.createElement("div", {
      className: "ecc-more-block"
    }, /*#__PURE__*/React.createElement("b", null, "Follow up with people who didn't open"), /*#__PURE__*/React.createElement("label", {
      className: "ecc-check"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: !!resend,
      onChange: e => patch("settings", {
        resend: e.target.checked ? {
          afterDays: 3,
          subject: c.content.subject ? `In case you missed it: ${c.content.subject}` : ""
        } : null
      })
    }), " Send it again after", /*#__PURE__*/React.createElement("input", {
      type: "number",
      min: "1",
      max: "14",
      "aria-label": "Days",
      style: {
        ...small,
        width: 56,
        margin: "0 6px"
      },
      disabled: !resend,
      value: resend ? resend.afterDays || 3 : 3,
      onChange: e => patch("settings", {
        resend: {
          ...resend,
          afterDays: Math.max(1, Math.min(14, Number(e.target.value) || 3))
        }
      })
    }), " days with the subject"), /*#__PURE__*/React.createElement("input", {
      style: {
        ...inp,
        maxWidth: 420
      },
      disabled: !resend,
      "aria-label": "Follow-up subject",
      value: resend ? resend.subject || "" : "",
      placeholder: "In case you missed it: \u2026",
      onChange: e => patch("settings", {
        resend: {
          ...resend,
          subject: e.target.value
        }
      })
    }), /*#__PURE__*/React.createElement("span", {
      className: "ecc-note"
    }, resend ? /*#__PURE__*/React.createElement(React.Fragment, null, "Planned for ", /*#__PURE__*/React.createElement("b", null, moment(planned).format("MMM D, YYYY h:mm A")), mode === "now" ? " (counted from when you schedule it)" : mode === "local" ? " (counted from when the sending window starts)" : "", ". A separate draft goes to the people who didn't open, with the same email and the subject above.") : "Off.")), /*#__PURE__*/React.createElement("div", {
      className: "ecc-more-block"
    }, /*#__PURE__*/React.createElement("b", null, "Sending speed"), /*#__PURE__*/React.createElement("div", {
      className: "ecc-inline"
    }, "Up to ", /*#__PURE__*/React.createElement("input", {
      type: "number",
      min: "100",
      step: "100",
      "aria-label": "Emails per hour",
      style: {
        ...small,
        width: 100
      },
      value: throttle,
      onChange: e => patch("schedule", {
        throttlePerHour: Math.max(100, Number(e.target.value) || 100)
      })
    }), " emails an hour"), /*#__PURE__*/React.createElement("span", {
      className: "ecc-note"
    }, "Your workspace default is ", num(wsSettings && wsSettings.throttlePerHour || 50000), " an hour. A new domain starts slower and speeds up over its first four sends (1,000, 5,000, 20,000, then 50,000 an hour).", wsSettings && wsSettings.quietHours && wsSettings.quietHours.enabled ? ` Nothing sends between ${hourText(wsSettings.quietHours.startHour)} and ${hourText(wsSettings.quietHours.endHour)}.` : ""))) : null);
  }
}

// ------------------------------------------------------------------ completion

/** Section completion: 1 audience · 2 content · 3 sender/service · 4 schedule. */
export function stepDone(c, step) {
  switch (step) {
    case 1:
      return !!(c.name && c.name.trim() && c.kind) && ((c.audience.include || []).length > 0 || (c.audience.people || []).length > 0);
    case 2:
      {
        const ct = c.content;
        const d = parseDesign(ct.designJson);
        return !!(ct.subject && ((ct.source || "composer") === "composer" ? d && (d.sections || []).length : (ct.html || "").trim()));
      }
    case 3:
      return !!c.rail && ((c.rail || "plunk") !== "plunk" || !!c.senderId);
    case 4:
      return !!(c.schedule.mode && c.schedule.mode !== "sto" && (c.schedule.mode !== "at" || c.schedule.sendAt));
    default:
      return false;
  }
}

/** Name + kind alone. */
export function basicsDone(c) {
  return !!(c.name && c.name.trim() && c.kind);
}